
export function decodeBase64(string) {
    return atob(string);
}

export function encodeBase64(string) {
    return btoa(string);
}

export function encodeNodeId(type, id) {
    // Example: Organizational:1
    let idInt = parseInt(id, 10);
    let string = `${type}:${idInt}`;

    return btoa(string);
}

export function decodeNodeId(string, onlyId = false) {
    let data = atob(string).split(':');
    let numericId = parseInt(data[1], 10);

    if (onlyId === true) {
        return numericId;
    }

    return {
        type: data[0],
        id: numericId
    };
}

/***
 * Get global id.
 * Accepts both strings and integers
 * @param model The GrahpQL Model
 * @param id Either integer id or relay global_id
 * @returns {*}
 */
export function getGlobalId(model, id) {
    if (isNaN(parseInt(id, 10))) {
        // Value is a string
        let data = decodeNodeId(id);

        if (data.type === model) {
            return id;
        }
        // No match

        return false;
    }

    return encodeNodeId(model, id);
}


export function createId() {
    let text = '';
    let possible = 'abcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}
